<template>
  <div class="text-center flex flex-wrap justify-around mt-20">
    <router-link
      class="w-full md:w-1/4 mb-2 md:mb-0 max-w-sm text-grey-9 hover:text-grey-7 px-4 py-2 border border-blue-7 rounded"
      :to="{name: 'admin.users'}"
    >
      <div class="w-full flex justify-center text-5xl">
        <users-icon></users-icon>
      </div>Manage Users
    </router-link>

    <router-link
      class="w-full md:w-1/4 mb-2 md:mb-0 max-w-sm text-grey-9 hover:text-grey-7 px-4 py-2 border border-blue-7 rounded"
      :to="{name: 'admin.channels'}"
      v-if="$auth.check('admin')"
    >
      <div class="w-full flex justify-center text-5xl">
        <box-icon></box-icon>
      </div>Manage Channels
    </router-link>

    <router-link
      class="w-full md:w-1/4 mb-2 md:mb-0 max-w-sm text-grey-9 hover:text-grey-7 px-4 py-2 border border-blue-7 rounded"
      :to="{name: 'admin.emotes'}"
    >
      <div class="w-full flex justify-center text-5xl">
        <smile-icon></smile-icon>
      </div>Manage Emotes
    </router-link>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Admin</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import {
  BoxIcon,
  SmileIcon,
  UsersIcon,
  ChevronRightIcon
} from "vue-feather-icons"

export default {
  name: "Admin",
  components: {
    BoxIcon,
    SmileIcon,
    UsersIcon,
    ChevronRightIcon
  }
}
</script>
